import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { FORMAT_ELEMENT_COMMAND } from 'lexical';
import { richTextEditorStrings } from '../../../i18n/components/richtTextEditor';

export function AlignmentPlugin() {
  const [editor] = useLexicalComposerContext();

  return (
    <span className="lexical-toolbar-group">
      <button
        type="button"
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'left')}
        className="lexical-toolbar-button"
        aria-label={richTextEditorStrings.alignment.left.label}
        title={richTextEditorStrings.alignment.left.title}
      >
        <i className="pi pi-align-left" />
      </button>
      <button
        type="button"
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'center')}
        className="lexical-toolbar-button"
        aria-label={richTextEditorStrings.alignment.center.label}
        title={richTextEditorStrings.alignment.center.title}
      >
        <i className="pi pi-align-center" />
      </button>
      <button
        type="button"
        onClick={() => editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'right')}
        className="lexical-toolbar-button"
        aria-label={richTextEditorStrings.alignment.right.label}
        title={richTextEditorStrings.alignment.right.title}
      >
        <i className="pi pi-align-right" />
      </button>
      <button
        type="button"
        onClick={() =>
          editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'justify')
        }
        className="lexical-toolbar-button"
        aria-label={richTextEditorStrings.alignment.justify.label}
        title={richTextEditorStrings.alignment.justify.title}
      >
        <i className="pi pi-align-justify" />
      </button>
    </span>
  );
}
